export enum ExportSettingsFields {
  Label = 'label',
  Description = 'description',
  Storage = 'storage',
  OverrideStorageConfig = 'overrideStorageConfig',
  StorageOverride = 'storageOverride',
  Overwrite = 'overwrite',
  Delete = 'delete'
}
